import React, { useState, useEffect }  from 'react';
import { FormattedMessage } from 'react-intl';
import { intl } from '../../../locales/localesConfig';
import JavascriptUtilsTooling from '../../../tooling/javascriptUtilsTooling';
import FormulaUtilsTooling from '../../../tooling/formulaUtilsTooling';
import FormatTooling from '../../../tooling/formatTooling';
import InterfaceTooling from '../../../tooling/interfaceTooling';
import Constants from '../../../definitions/constants';
import $ from 'jquery';

import GlassPopup from '../common/interface/glassPopup';
import FieldInfo from '../common/inputs/fieldInfo';
import Spinner from '../common/interface/spinner';
import Button from '../common/inputs/button';
import CheckBox from '../common/inputs/checkBox';
import Select from '../common/inputs/select';
import TextBox from '../common/inputs/textBox';
import ObjectTableColumnEditor from './objectInputs/objectTableColumnEditor';
import Spreadsheet from '../common/inputs/spreadsheet';

const TableEditorPopup = props => {
  const {
    handleShowPopup,
    fullLoading,
    formulaToEditObject,
    handleValidateAndSet,
    validationStatus,
    dimensionsList,
    onChangeTableData,
    onChangeTableOptions,
    handleSelectCell,
    handleControlButtons,
    tableSelectedRow,
    tableSelectedCol,
    tableTargetRows,
    popupState
  } = props;
  
  let tableDefinition = (popupState && popupState.show && formulaToEditObject && formulaToEditObject.formulaArray) ? formulaToEditObject.formulaArray : null;
  return (
    <GlassPopup
      className={"form_popup table_editor_popup full_screen_popup"}
      title={intl.formatMessage({id:"polynomialAdmin.tableEditor.title"})}
      handleButton={handleValidateAndSet}
      buttonText={(<FormattedMessage id={"polynomialAdmin.tableEditor.validateAndSetButton"}/>)}
      handleAlternativeButton={(formulaToEditObject && !formulaToEditObject.onlyRead) ? handleShowPopup : null}
      alternativeButtonText={(<FormattedMessage id={"polynomialAdmin.tableEditor.cancelButton"}/>)}
      {...props}
      handleButton={(formulaToEditObject && !formulaToEditObject.onlyRead) ? handleValidateAndSet : null}
    >
      {(tableDefinition) && (
        <div className="table_editor_popup_inner">
          <div className="table_editor_popup_left_panel">
            <Select 
              data-path="type"
              value={tableDefinition.type}
              onChange={onChangeTableOptions}
              labelLocale={<FormattedMessage id="polynomialAdmin.tableEditor.fields.type"/>}
              options={InterfaceTooling.getSelectArray("selectKeys.formulaEditor.tableReturnTypes","polynomialAdmin.tableEditor.fields.selectTypesValues")}
              className={("invalid_blank_type" in formulaToEditObject) ? "has_error" : null}
              disabled={formulaToEditObject.onlyRead}
            />
            <ObjectTableColumnEditor
              data-path="columns"
              values={tableDefinition.columns.map(column_item => {
                return {
                  name: column_item.name,
                  type: column_item.type,
                  label: column_item.options.label,
                  hide: column_item.options.hide,
                  format: column_item.options.format,
                  validated_by_dim_id: column_item.options.validated_by_dim_id
                };
              })}
              dimensionOptions={InterfaceTooling.getSelectArrayFromArrayOfObjects(dimensionsList.filter(dimensionItem => 
                (dimensionItem.domain_input_source==Constants.selectKeys.dimension.domain_input_source.DEF_USER &&
                (dimensionItem.data_type==Constants.selectKeys.dimension.dataType.STRING || dimensionItem.data_type==Constants.selectKeys.dimension.dataType.NUMBER))), "id", "name")}
              onChange={onChangeTableOptions}
              disabled={formulaToEditObject.onlyRead}
              className={(("invalid_column_dimension" in formulaToEditObject) || ("invalid_blank_columns" in formulaToEditObject)) ? "has_error" : null}
            />
            <div className="table_editor_form_label">
              {intl.formatMessage({id:"polynomialAdmin.tableEditor.returnReportsOptionsLabel"}) + ":"}                     
            </div>
            <TextBox 
              styleType={Constants.interface.inputs.styleType.OUTLINED}
              type={Constants.interface.inputs.type.TEXT}
              data-path="options.format"
              value={tableDefinition.options.format}
              onChange={onChangeTableOptions}
              disabled={formulaToEditObject.onlyRead}
              labelLocale={<FormattedMessage id="polynomialAdmin.tableEditor.fields.format"/>}
            />            
            <Select 
              data-path="options.hide"
              value={tableDefinition.options.hide}
              onChange={onChangeTableOptions}
              labelLocale={<FormattedMessage id="polynomialAdmin.tableEditor.fields.hide"/>}
              disabled={formulaToEditObject.onlyRead}
              options={InterfaceTooling.getSelectArray("selectKeys.formulaEditor.optionsBoolean","polynomialAdmin.formulaEditor.entityEditor.optionsBooleanSelectValues")}
            />
          </div>
          <div className="table_editor_popup_main_panel">
            {!formulaToEditObject.onlyRead && (
              <div className="table_editor_popup_control_buttons">
                <div className="table_editor_popup_control_buttons_editable_rows">
                  <FormattedMessage id="polynomialAdmin.tableEditor.editableRowsLabel"/>: {tableDefinition.instances.length}
                </div>
                <Button
                  className={"table_editor_popup_control_buttons_button"}
                  onClick={handleControlButtons}
                  data-action={"add_rows"}
                  disabled={(tableSelectedRow != null && (+tableTargetRows)>0) ? false : true}
                  labelLocale={<FormattedMessage id="polynomialAdmin.tableEditor.topControlsButtons.addRows"/>}
                />
                <Button
                  className={"table_editor_popup_control_buttons_button"}
                  onClick={handleControlButtons}
                  data-action={"delete_rows"}
                  disabled={(tableSelectedRow != null && (+tableTargetRows)>0) ? false : true}
                  labelLocale={<FormattedMessage id="polynomialAdmin.tableEditor.topControlsButtons.deleteRows"/>}
                />
                <TextBox 
                  styleType={Constants.interface.inputs.styleType.OUTLINED}
                  type={Constants.interface.inputs.type.TEXT}
                  data-action={"target_rows"}
                  value={tableTargetRows}
                  dataType={Constants.selectKeys.metric.dataType.NUMBER}
                  onChange={handleControlButtons}
                />
                <Button
                  className={"table_editor_popup_control_buttons_button"}
                  onClick={handleControlButtons}
                  data-action={"paste_instances"}
                  disabled={(tableSelectedRow != null && tableSelectedCol!=null && tableDefinition.columns_display.find(item => item.prop==tableSelectedCol).type==Constants.selectKeys.formulaEditor.tableColumnTypes.VALIDATE_BY_DIMENSION) ? false : true}
                  labelLocale={<FormattedMessage id="polynomialAdmin.tableEditor.topControlsButtons.pasteInstances"/>}
                />
                <Button
                  className={"table_editor_popup_control_buttons_button"}
                  onClick={handleControlButtons}
                  data-action={"set_defect"}
                  disabled={(tableSelectedRow != null && tableSelectedCol!=null && tableSelectedCol!=tableDefinition.columns_display[tableDefinition.columns_display.length-1].prop && tableDefinition.columns_display.find(item => item.prop==tableSelectedCol).type!=Constants.selectKeys.formulaEditor.tableColumnTypes.RANGE) ? false : true}
                  labelLocale={<FormattedMessage id="polynomialAdmin.tableEditor.topControlsButtons.setDefect"/>}
                />
              </div>
            )}
            <div className={"table_editor_popup_main_inner" + ((formulaToEditObject.invalid_table_error) ? " table_editor_editor_input_error" : "")}>
              <React.Fragment>
                <Spinner/>
                <Spreadsheet
                  columns={tableDefinition.columns_display}
                  rows={tableDefinition.instances}
                  handleChangeData={onChangeTableData}
                  handleSelectCell={handleSelectCell}
                  disabled={formulaToEditObject.onlyRead}
                />
              </React.Fragment>
            </div>
          </div>
        </div>
      )}
    </GlassPopup>
  );
};

export default TableEditorPopup;



// WEBPACK FOOTER //
// ./source/client/components/tableEditor/tableEditorPopup.jsx